// extracted by mini-css-extract-plugin
module.exports = {"datepickerDiv":"PatientForm_datepickerDiv__1qOOR","card_body":"PatientForm_card_body__3R4Aq","form_column":"PatientForm_form_column__1FurQ"};